import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './BroadSignRejectCreationModal.scss'
import Modal from '../../../../components/Modal'
import Button, { ButtonTheme } from '../../../../components/Form/Button'
import { BroadSignCreationModel } from '../../../../api/broadSign/models/broad-sign-creation.model'
import BroadSignService from '../../services/broad-sign.service'
import { AppContext } from '../../../../contexts/AppContext'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const BroadSignRejectCreationModal: React.FC<{
  creation?: BroadSignCreationModel
  isModalOpen: boolean
  setModalOpen: (open: boolean) => void
  onStatusChange?: (status: 'rejected') => void
}> = ({ creation, isModalOpen, setModalOpen, onStatusChange }) => {
  const { t } = useTranslation()
  const { addNotification } = useContext(AppContext)
  const [note, setNote] = useState('')
  const [rejecting, setRejecting] = useState(false)

  // one modal serves every creation it is opened on, the reason of the last one must not carry over
  useEffect(() => {
    if (isModalOpen) {
      setNote('')
    }
  }, [isModalOpen])

  const rejectCreation = () => {
    if (!creation) {
      return
    }

    setRejecting(true)

    void BroadSignService.rejectCreation(
      creation.id,
      note,
      addNotification,
      t,
      setModalOpen,
      onStatusChange
    ).finally(() => setRejecting(false))
  }

  return (
    <Modal
      title={`${t('broadSign.rejectionReason')}`}
      classNameOverlay='BroadSignRejectCreationModal'
      isOpen={isModalOpen}
      onClose={(isOpen: boolean) => void setModalOpen(isOpen)}
      footer={
        <div className={'BroadSignRejectCreationModal__footer'}>
          <Button
            theme={ButtonTheme.BLUE}
            icon={rejecting ? faSpinner : undefined}
            // the reason is only passed on to BroadSign, and the backend asks of it exactly what
            // this asks: that it is not blank. whitespace counts as blank there too
            disabled={rejecting || !note.trim()}
            onClick={rejectCreation}
          >
            {t('common.save')}
          </Button>
          <Button
            theme={ButtonTheme.BLUE_OUTLINE}
            disabled={rejecting}
            onClick={() => void setModalOpen(false)}
          >
            {t('common.cancel')}
          </Button>
        </div>
      }
    >
      {isModalOpen && (
        <div>
          <textarea
            autoFocus
            className='Input__field BroadSignRejectCreationModal__input'
            onChange={event => setNote(event.target.value)}
            value={note}
          />
        </div>
      )}
    </Modal>
  )
}

export default BroadSignRejectCreationModal
